import React, { FunctionComponent } from 'react';

import { ReactFCC } from '@types';

import {
  Image,
  Text,
  PricePerUnit,
  Quantity,
  TotalPrice,
  Button,
  IImageProps,
  ITextProps,
  IPricePerUnitProps,
  IQuantityProps,
  ITotalPriceProps,
  IButtonProps,
} from './components';
import { GeneralProductItemProvider, IGeneralProductItemContext } from './context/GeneralProductItemContext';
import { StyledGeneralProductRow } from './styled';

export interface IGeneralProductItemProps extends IGeneralProductItemContext {
  dataTestId?: string;
  productCode?: string;
}

interface IGeneralProductItemComposition {
  Image: FunctionComponent<IImageProps>;
  Text: FunctionComponent<ITextProps>;
  PricePerUnit: FunctionComponent<IPricePerUnitProps>;
  Quantity: FunctionComponent<IQuantityProps>;
  TotalPrice: FunctionComponent<ITotalPriceProps>;
  Button: FunctionComponent<IButtonProps>;
}

export const GeneralProductItem: ReactFCC<IGeneralProductItemProps> & IGeneralProductItemComposition = ({
  children,
  dataTestId,
  productCode,
  ...toContext
}) => {
  return (
    <GeneralProductItemProvider {...toContext}>
      <StyledGeneralProductRow data-testid={dataTestId} className={dataTestId} data-productCode={productCode}>
        {children}
      </StyledGeneralProductRow>
    </GeneralProductItemProvider>
  );
};

GeneralProductItem.Image = Image;
GeneralProductItem.Text = Text;
GeneralProductItem.PricePerUnit = PricePerUnit;
GeneralProductItem.Quantity = Quantity;
GeneralProductItem.TotalPrice = TotalPrice;
GeneralProductItem.Button = Button;
